import { render } from "./ViewCatQuestions.vue?vue&type=template&id=60c04116"
import script from "./ViewCatQuestions.vue?vue&type=script&lang=ts"
export * from "./ViewCatQuestions.vue?vue&type=script&lang=ts"

import "./ViewCatQuestions.vue?vue&type=style&index=0&id=60c04116&lang=scss"
script.render = render

export default script